import { NativeSelect } from "@mantine/core"
import React from "react"
import { GenericFieldProps } from "src/utils/forms"

const getVenueRoleOptions = (department: string) => {
    if (!department) return []
    return [
        { label: `Admin`, value: `venue_${department}_administrator` },
        { label: `User`, value: `venue_${department}_user` }
    ]
}

export const VenueRoleSelect: React.FC<GenericFieldProps> = ({
    id, name, label, onChange, onBlur, value, error, required, disabled, description, classNames, getValues
}) => {

    const department = getValues?.type || ''
    const options = React.useMemo(() => getVenueRoleOptions(department), [department])

    React.useEffect(() => {
        if (department && value && !value.startsWith(`venue_${department}_`)) {
            onChange(`venue_${department}_administrator`)
        }
    }, [department])

    return (
        <NativeSelect
            id={id}
            name={name}
            label={label}
            data={[
                { label: 'Select Role...', value: '' },
                ...options
            ]}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                onChange(e.target.value)
            }}
            onBlur={onBlur}
            value={value || ''}
            error={error as string}
            required={required}
            disabled={!department || disabled}
            description={description}
            classNames={classNames}
        />
    )
}
